import React from 'react'

import styles from './styles.module.scss'
import cn from 'classnames'

import { userPermission, profilePaths, billingPermission } from '../../constants/constants'
import { useSelector } from 'react-redux'

import { CellsIcon, SearchSeafarersIcon, StatisticIcon, UsersIcon } from '../../UI/Icons/Icons'
import MessagesIcon from '../../UI/Icons/MessagesIcon'
import UserIcon from '../../UI/Icons/UserIcon'
import SettingsIcon from '../../UI/Icons/SettingsIcon'
import {
  isPathAvailable as isExistUserPermission,
  isServiceAvailable as isExistBillingPermission,
} from '../../helpers/helpers'

const useNavigationProfile = () => {
  const messagesCount = useSelector(({ chat }) => chat.global_undelivered)
  const isActiveCompany = useSelector(({ company }) => company.is_active)
  const isInactiveCompany = !isActiveCompany

  const navigation = {
    [profilePaths.seafarers_search]: {
      icon: <SearchSeafarersIcon />,
      title: 'Seafarers',
      paths: [profilePaths.seafarers_search, profilePaths.seafarers_favorites, profilePaths.seafarers_request],
      disabled:
        !isInactiveCompany &&
        (!isExistUserPermission(userPermission.seafarers_favourites) &&
          !isExistUserPermission(userPermission.vacancy_requests)),
    },
    [profilePaths.chat]: {
      icon: (
        <span className={cn({ [styles.notSeen]: messagesCount })}>
          <MessagesIcon />
        </span>
      ),
      title: 'Chats',
      disabled:
        !isInactiveCompany &&
        !Boolean(
          isExistUserPermission(userPermission.seafarer_chat) &&
            isExistBillingPermission(billingPermission.instant_messaging)
        ),
    },
    [profilePaths.create_vacancy]: {
      icon: <CellsIcon />,
      title: 'Vacancies',
      paths: [profilePaths.create_vessel, profilePaths.create_vacancy, profilePaths.vacancy_manager],
      disabled:
        !isInactiveCompany &&
        (!isExistUserPermission(userPermission.vacancies) && !isExistUserPermission(userPermission.vessels)),
    },
    [profilePaths.users_create]: {
      icon: <UsersIcon />,
      title: 'Users',
      paths: [profilePaths.users_create, profilePaths.role_permissions],
      disabled: !isInactiveCompany && !isExistUserPermission(userPermission.users),
    },
    [profilePaths.company_data]: {
      icon: <UserIcon />,
      title: 'Company',
      disabled: !isInactiveCompany && !isExistUserPermission(userPermission.company_profile),
    },
    [profilePaths.statistic]: {
      icon: <StatisticIcon />,
      title: 'Statistic',
      disabled: false,
    },
    [profilePaths.settings]: {
      icon: <SettingsIcon />,
      title: 'Settings',
      disabled: false,
    },
  }

  return { navigation }
}

export default useNavigationProfile
